import { CheckCircle, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { FlowState } from "../../pages/FlowPage";
import { BigButton } from "../BigButton";

interface Props {
  state: FlowState;
  onNext: (update: Partial<FlowState>) => void;
  onRetry: () => void;
  onDone: () => void;
}

export function ResultStep({ state, onNext, onRetry, onDone }: Props) {
  const { t } = useTranslation();
  const success = state.payment_success === true;

  return (
    <div className="flex flex-col items-center justify-center gap-8 h-full p-8">
      {success ? (
        <CheckCircle className="w-28 h-28 text-green-500" aria-hidden="true" />
      ) : (
        <XCircle className="w-28 h-28 text-red-500" aria-hidden="true" />
      )}
      <h2 className="text-4xl font-bold text-center">
        {success ? t("flow.result.successTitle") : t("flow.result.failTitle")}
      </h2>
      {success && state.amount_cents && (
        <p className="text-3xl text-[var(--kiosk-brand-muted)]">
          ${(state.amount_cents / 100).toFixed(2)}
        </p>
      )}
      {state.error_message && (
        <p role="alert" className="text-red-600 text-xl text-center">
          {state.error_message}
        </p>
      )}
      <div className="flex gap-6 mt-4">
        {success ? (
          <>
            <BigButton variant="secondary" onClick={onDone}>
              {t("flow.result.done")}
            </BigButton>
            <BigButton variant="primary" onClick={() => onNext({})}>
              {t("flow.receipt.title")}
            </BigButton>
          </>
        ) : (
          <>
            <BigButton variant="secondary" onClick={onDone}>
              {t("flow.result.done")}
            </BigButton>
            <BigButton variant="primary" onClick={onRetry}>
              {t("flow.result.tryAgain")}
            </BigButton>
          </>
        )}
      </div>
    </div>
  );
}
